import { call, put, SagaReturnType, takeLatest } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  GET_FIVE_DAY_ARD_WINDOW_REQUEST,
  GET_FIVE_DAY_ARD_WINDOW_SUCCESS,
  GET_FIVE_DAY_ARD_WINDOW_FAILURE,
  GET_FIVE_DAY_ARD_WINDOW_LOADING,
} = therapyPlanningAction;

function* getFiveDayArdWindow(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_FIVE_DAY_ARD_WINDOW_LOADING });
    const response = yield call(therapyPlanningService.getFiveDayArdWindow, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_FIVE_DAY_ARD_WINDOW_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_FIVE_DAY_ARD_WINDOW_FAILURE, payload: error });
  }
}

function* getFiveDayArdWindowSaga() {
  yield takeLatest(GET_FIVE_DAY_ARD_WINDOW_REQUEST, getFiveDayArdWindow);
}

export default getFiveDayArdWindowSaga;
